import usePermissions from "shared/hooks/usePermissions";

// Nem admin felhasználó csak ezeket a csomag oszlopokat láthatja
export const RESTRICTED_PACKAGE_COLUMNS = [
  "trackingNumber",
  "orderShopNumber",
  "customerName",
  "customerEmail",
  "customerPhone",
  "currentAddress",
  "sourceAddress",
  "targetAddress",
];

const useAllowedPackageColumns = () => {
  const { isAdmin } = usePermissions();

  return isAdmin ? undefined : RESTRICTED_PACKAGE_COLUMNS;
};

export default useAllowedPackageColumns;
